import React from 'react';
import './AccuracyModels.css';

// Import the new image
import tableImage from '../../assets/images/accuracy-table.png';

const AccuracyModels = () => {
  return (
    <section className="accuracy-models-section">
      <div className="accuracy-models-container">
        {/* Left Column: Text Content */}
        <div className="accuracy-text-col">
          <h2>High-accuracy models trained on CRISHI data</h2>
          <p>
            Our forecasting model has been trained on our 15+ years of back data with a delta ranging from 1-2%, giving you highly reliable price projections, you can plan around.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="accuracy-image-col">
          <img src={tableImage} alt="Table showing high-accuracy forecasting models" />
        </div>
      </div>
    </section>
  );
};

export default AccuracyModels;